import { JSX as LocalJSX, defineCustomElements } from 'blip-ds/loader';
import { AppProvider } from 'contexts/AppContext';
import { LoadingProvider } from 'contexts/LoadingContext';
import i18n from 'i18n/i18n';
import { DetailedHTMLProps, HTMLAttributes, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
type StencilToReactElements<T = LocalJSX.IntrinsicElements> = {
    [P in keyof T]?: T[P] &
        Omit<DetailedHTMLProps<HTMLAttributes<T[P]>, T[P]>, 'className'> & {
            class?: string;
        };
};
type StencilToReactRef<T = HTMLElementTagNameMap> = {
    [P in keyof T]: {
        ref?: DetailedHTMLProps<HTMLAttributes<T[P]>, T[P]>['ref'];
    };
};
type StencilToReact<T = LocalJSX.IntrinsicElements, U = HTMLElementTagNameMap> = StencilToReactElements<T> &
    StencilToReactRef<U>;
declare global {
    export namespace JSX {
        interface IntrinsicElements extends StencilToReact {
            [name: string]: any;
        }
    }
}
defineCustomElements(window);
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <Suspense fallback={<div>{i18n.t('go-personal-loading')}</div>}>
        <LoadingProvider>
            <AppProvider>
                <App />
            </AppProvider>
        </LoadingProvider>
    </Suspense>,
);
